import type { SubscriptionInterval, SubscriptionPlan } from './entitlements';
import { PLAN_PRICE_KEYS } from './planPrices';

// USD list prices shown on the web pricing cards; in-app store products are priced to match (owner, 12 Oct 2026).
export const WEB_PLAN_USD = {
  MEMBER: { MONTHLY: 29, ANNUAL: 289 },
  PRO: { MONTHLY: 69, ANNUAL: 689 },
  TEAM: { ANNUAL: 1788 },
} as const;

export type WebPlan = { plan: SubscriptionPlan; interval: SubscriptionInterval; usd: number };

// Every plan and period sold on the web (the Stripe/PayPal price keys) with its list price.
export const WEB_PLANS: readonly WebPlan[] = PLAN_PRICE_KEYS.map(({ plan, interval }) => ({
  plan,
  interval,
  usd: (WEB_PLAN_USD[plan] as Partial<Record<SubscriptionInterval, number>>)[interval]!,
}));
